var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 609.45 793.7",
    style: {
      enableBackground: "new 0 0 609.45 793.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000175284672388834731480000008356241879831540651_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#61A60E;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#264E63;}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 302.1045,
    cy: 270.461,
    r: 137.8687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E8BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1736,
    style: {
      stopColor: "#ABC29B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    style: {
      stopColor: "#597E5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003F1B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.79,302.25c-0.5-85.45,69.29-154.75,154.74-154.75c70.47,0,129.19,47.26,147.88,111.7 c0,0-24.3-55.81-92.38-55.81c-68.09,0-121.21,96.51-56.87,159.37c0.32,0.31-14.88,25.71-50.52,30.16 C211.76,398.14,151.15,362.98,150.79,302.25z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000101790245459411546310000014753516447153191854_",
    cx: 307.3464,
    cy: 332.5655,
    r: 137.8682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74CFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1434,
    style: {
      stopColor: "#67B4D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4514,
    style: {
      stopColor: "#4B7FA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    style: {
      stopColor: "#21406C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9683,
    style: {
      stopColor: "#1C3664"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000101790245459411546310000014753516447153191854_)"
    },
    d: " M458.66,300.77c0.5,85.46-69.28,154.75-154.74,154.75c-70.47,0-129.18-47.25-147.88-111.7c0,0,23.94,56.33,92.02,56.33 c68.09,0,118.96-98.76,55.36-161.61c-0.32-0.31,16.73-23.98,52.38-28.43C397.7,204.88,458.3,240.05,458.66,300.77z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M221.96,536.05v-24.54c0-4.59-1.28-8.36-3.6-10.6c-3.09-3.01-7.09-3.25-8.24-3.25c-1.15,0-5.15,0.23-8.24,3.24 c-1.35,1.31-3.61,4.42-3.53,10.59v24.55h-8.07v-27.34c0.32-5.67,2.91-10.51,5.19-12.62c2.09-1.93,6.43-5.96,14.18-5.96 c0.16,0,0.33,0,0.49,0c6.15,0.13,10.54,1.84,14.25,5.55c3.68,3.6,5.64,9.07,5.64,15.83v24.54H221.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.33,537.05c-12.85,0-23.3-10.49-23.3-23.38c0-12.73,10.41-23.29,23.21-23.53 c9.94,0.09,16.83,5.97,19.98,11.45c2.56,4.08,3.71,8.83,3.42,14.08l-0.08,1.26H150.4c1.09,6.91,7.69,12.58,14.85,12.58 c4.81-0.1,9-2.03,11.77-5.44l0.23-0.29l9.32-0.25l-1.24,2.06C181.12,532.66,173.45,537.05,165.33,537.05z M180.17,509.4 c-2.09-8.05-9.05-11.73-14.84-11.73c-5.84,0-12.81,3.68-14.78,11.73H180.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116.13,537.05c-12.85,0-23.3-10.49-23.3-23.38c0-12.73,10.41-23.29,23.21-23.53 c9.94,0.09,16.83,5.97,19.98,11.45c2.56,4.08,3.71,8.83,3.42,14.08l-0.07,1.26H101.2c1.1,6.91,7.69,12.58,14.85,12.58 c4.81-0.1,8.99-2.03,11.77-5.44l0.23-0.29l9.31-0.25l-1.23,2.06C131.92,532.66,124.26,537.05,116.13,537.05z M130.97,509.4 c-2.09-8.05-9.05-11.73-14.84-11.73c-5.84,0-12.81,3.68-14.78,11.73H130.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.37,507.99c0.1-5.22,2.51-9.4,4.65-11.5c3.36-3.28,8.62-5.23,13.26-5.55l0.57-0.04v6.76l-0.49,0.04 c-3.68,0.3-6.76,1.64-8.72,3.97c-1.77,2.21-2.81,5.09-2.81,8.37v25.19h-6.46V507.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.18,552.61c-4.23,0-18.4-1.19-22.86-16.45l-0.5-1.71h8.4l0.2,0.51c1.51,3.78,5.43,10.13,14.69,10.13 c6.67,0,13.8-3.71,13.92-14.11c-4.11,4.44-10.31,6.07-15.08,6.07c-11.24,0-23.38-8.88-23.38-23.22c0-6.63,2.58-12.73,7.28-17.18 c4.36-4.14,10.23-6.51,16.1-6.51c4.02,0,11.63,1.09,17.45,8.35c3.88,4.66,5.69,10.28,5.69,17.67v11.92c0,2.32,0,4.96-0.51,7.72 c-0.59,3.26-1.78,6.03-3.61,8.49C66.29,552.21,56.15,552.61,54.18,552.61z M52.95,497.67c-8.44,0-15.31,7.18-15.31,16 c0,8.74,6.87,15.85,15.31,15.85c10.5,0,15.39-9.46,15.39-15.85C68.33,504.84,61.43,497.67,52.95,497.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.77,498.99c-5.56-6.94-12.88-8.05-16.83-8.05c-11.37,0-22.57,9.15-22.57,22.88 c0,13.59,11.22,22.42,22.57,22.42c5.75,0,12.22-2.3,15.8-7.46l0.08,1.93c0,11.26-7.85,15.18-14.73,15.18 c-9.93,0-13.95-6.92-15.44-10.63h-6.77l0.2,0.68c3.95,13.52,15.99,15.87,22.09,15.87c1.71,0,11.67-0.37,17.15-8 c1.99-2.66,2.97-5.45,3.47-8.16c0.49-2.67,0.49-5.27,0.49-7.57v-11.92C75.29,508.63,73.39,503.32,69.77,498.99z M52.95,530.32 c-9.23,0-16.11-7.75-16.11-16.65c0-8.99,6.89-16.81,16.11-16.81c9.16,0,16.19,7.82,16.19,16.81 C69.14,520.65,63.73,530.32,52.95,530.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M577.84,549.19c-1.36,1.36-3.01,2.05-4.93,2.05c-1.92,0-3.58-0.69-4.95-2.05c-1.36-1.36-2.04-3.02-2.04-4.97 c0-1.08,0.22-2.06,0.67-2.96c0.44-0.94,1.07-1.74,1.86-2.4c1.3-1.07,2.76-1.61,4.38-1.61c1.07,0,2.04,0.2,2.91,0.61 c1.24,0.54,2.23,1.4,2.99,2.57c0.76,1.18,1.14,2.44,1.14,3.8C579.88,546.16,579.2,547.82,577.84,549.19z M573.98,544.98l2.45,3.15 c1.15-1.18,1.66-2.44,1.66-3.92c0-0.78-0.2-1.6-0.6-2.46c-0.4-0.79-0.91-1.41-1.56-1.87c-0.91-0.65-1.94-0.98-3.07-0.98 c-1.41,0-2.62,0.52-3.63,1.56c-1.02,1.05-1.53,2.29-1.53,3.74c0,1.48,0.51,2.73,1.53,3.78c1.01,1.04,2.23,1.56,3.68,1.56 c1.3,0,2.42-0.43,3.38-1.29h-2.19l-1.84-2.45v2.45h-1.97v-8.07h1.77c1.07,0,1.91,0.19,2.47,0.62c0.6,0.48,0.9,1.13,0.9,1.91 c0,0.53-0.16,1.02-0.48,1.47C574.69,544.55,574.37,544.82,573.98,544.98z M572.24,543.55c0.98,0,1.28-0.32,1.28-0.8 c0-0.42-0.27-0.73-1.23-0.73L572.24,543.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M474.85,537.42c-13.48,0-24.03-10.35-24.03-23.57c0-11.51,8.99-23.42,24.03-23.42c6.02,0,14.14,2.4,18.86,9.14 c2.92,4.08,4.35,8.65,4.48,14.38v22.18h-8.08v-4.83C484.57,536.78,477.71,537.42,474.85,537.42z M474.85,497.97 c-7.93,0-15.95,5.53-15.95,16.11c0,9.15,6.71,15.8,15.95,15.8c8.73,0,15.57-6.97,15.57-15.87 C490.42,505.16,483.44,497.97,474.85,497.97z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "545.67,551.23 553.62,533.65 536.66,491.51 545.26,491.51 557.82,523 571.25,491.51 579.88,491.51  554.26,551.23  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M532.73,536.41v-24.57c0-4.6-1.28-8.37-3.6-10.62c-3.1-3.02-7.1-3.25-8.25-3.25s-5.16,0.23-8.26,3.25 c-2.34,2.27-3.59,6.03-3.53,10.61v24.59h-8.08v-27.39c0.32-5.68,2.91-10.52,5.19-12.63c2.09-1.94,6.43-5.97,14.2-5.97 c0.16,0,0.33,0,0.49,0c6.16,0.13,10.56,1.85,14.27,5.56c3.69,3.6,5.64,9.08,5.64,15.84v24.57H532.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M400.63,551.23l0-37.26c0.13-5.75,1.56-10.32,4.48-14.4c4.71-6.73,12.83-9.13,18.86-9.13 c15.04,0,24.03,11.91,24.03,23.42c0,13.22-10.56,23.57-24.03,23.57c-2.85,0-9.71-0.63-15.26-6.11v19.93H400.63z M423.97,497.97 c-8.58,0-15.56,7.19-15.56,16.03c0,8.9,6.84,15.87,15.56,15.87c9.24,0,15.95-6.64,15.95-15.8 C439.93,503.5,431.9,497.97,423.97,497.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M387.66,536.41V510.6c0-4.61-0.87-6.55-1.76-8.14c-1.71-2.89-4.69-4.49-8.41-4.49c-3.71,0-6.7,1.6-8.41,4.51 c-0.88,1.57-1.75,3.51-1.75,8.12v25.81h-8.08V510.6c0-4.61-0.87-6.55-1.76-8.14c-1.71-2.89-4.7-4.49-8.41-4.49 c-3.71,0-6.7,1.6-8.42,4.51c-0.88,1.57-1.75,3.51-1.75,8.12v25.81h-8.08v-27.08c0.06-3.96,0.76-7.29,2.08-9.89 c0.45-0.89,0.98-1.69,1.57-2.4c0.32-0.38,0.59-0.66,0.79-0.85c0.06-0.06,0.12-0.12,0.16-0.16c3.12-3.64,7.71-5.53,13.63-5.6l0.14,0 c3.54,0,10.25,1.47,14.07,6.84c3.84-5.36,10.62-6.84,14.2-6.84c6.78,0,18.24,4.12,18.24,19.56v26.43H387.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303.39,537.42c-12.65,0-23.34-10.62-23.34-23.18c0-14.7,12.11-23.8,23.34-23.8 c12.73,0,23.49,10.76,23.49,23.49C326.88,526.66,316.12,537.42,303.39,537.42z M303.47,497.97c-9.47,0-15.34,8.4-15.34,16.19 c0,8.67,6.88,15.72,15.34,15.72c7.54,0,15.33-6.05,15.33-16.18C318.8,502.97,309.65,497.97,303.47,497.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.6,537.42c-13.48,0-24.03-10.29-24.03-23.42c0-13,10.78-23.57,24.03-23.57c7.88,0,17.86,3.85,22.23,14.65 l0.74,1.84h-8.73l-0.23-0.43c-2.83-5.34-8.01-8.53-13.86-8.53c-7.92,0-16.11,5.94-16.11,15.88c0,8.99,7.08,16.03,16.11,16.03 c8.66,0,12.47-5.49,13.71-7.85l0.22-0.41l9.14-0.36l-1.04,2C273.96,532.65,266.49,537.42,256.6,537.42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.259269b49ea28cfd287bbbe55edc6ca8.svg";
export { ForwardRef as ReactComponent };